(function (window, $) {
  var Cls = {};

  Cls.init = function () {};

  Cls.side = function (target, move, delay, duration, easing, func) {
    var _dl = target.css("left");
    target
      .stop()
      .queue([])
      .css({
        left: move,
        //
        opacity: 0,
      })
      .delay(delay)
      .animate(
        {
          left: _dl,
          opacity: 1,
        },
        duration,
        easing,
        func
      );
  };

  Cls.vertical = function (target, move, delay, duration, easing, func) {
    var _dt = target.css("top");
    target
      .stop()
      .queue([])
      .css({
        top: move,

        opacity: 0,
      })
      .delay(delay)
      .animate(
        {
          top: _dt,
          opacity: 1,
        },
        duration,
        easing,
        func
      );
  };

  Cls.zoomIn = function (target, duration, easing, delay, func) {
    var _dw = target.width();
    var _dh = target.height();
    var _dt = Number(target.css("top").replace("px", ""));
    var _dl = Number(target.css("left").replace("px", ""));
    target
      .stop()
      .queue([])
      .css({
        top: _dt + _dh / 2 + "px",
        left: _dl + _dw / 2 + "px",
        visibility: "visible",
      })
      .delay(delay)
      .animate(
        {
          top: _dt + "px",
          left: _dl + "px",
          opacity: 1,
        },
        duration,
        easing,
        func
      );

    target
      .find("img")
      .stop()
      .queue([])
      .css({
        height: 0,
        width: 0,
      })
      .delay(delay)
      .animate(
        {
          height: _dh + "px",
          width: _dw + "px",
        },
        duration,
        easing,
        func
      );
  };

  Cls.fadeHalfSizeZoomIn = function (target, duration, easing, delay, func) {
    var _dw = target.width();
    var _dh = target.height();
    var _dt = Number(target.css("top").replace("px", ""));
    var _dl = Number(target.css("left").replace("px", ""));
    target
      .stop()
      .queue([])
      .css({
        top: _dt + _dh / 4 + "px",
        left: _dl + _dw / 4 + "px",
        opacity: 0,
        visibility: "visible",
      })
      .delay(delay)
      .animate(
        {
          top: _dt + "px",
          left: _dl + "px",
          opacity: 1,
        },
        duration,
        easing,
        func
      );

    target
      .find("img")
      .stop()
      .queue([])
      .css({
        height: _dh / 2,
        width: _dw / 2,
      })
      .delay(delay)
      .animate(
        {
          height: _dh + "px",
          width: _dw + "px",
        },
        duration,
        easing,
        func
      );
  };

  Cls.zoomInFade = function (target, duration, easing, delay, func) {
    var _dw = target.width();
    var _dh = target.height();
    var _dt = Number(target.css("top").replace("px", ""));
    var _dl = Number(target.css("left").replace("px", ""));
    target
      .stop()
      .queue([])
      .css({
        top: _dt + _dh / 2 + "px",
        left: _dl + _dw / 2 + "px",
        opacity: 1,
        visibility: "visible",
      })
      .delay(delay)
      .animate(
        {
          top: _dt + "px",
          left: _dl + "px",
          opacity: 0,
        },
        duration,
        easing,
        func
      );

    target
      .find("img")
      .stop()
      .queue([])
      .css({
        height: 0,
        width: 0,
      })
      .delay(delay)
      .animate(
        {
          height: _dh + "px",
          width: _dw + "px",
        },
        duration,
        easing,
        func
      );
  };

  Cls.zoomOutFade = function (target, duration, easing, delay, func, options) {
    var _dw = target.width();
    var _dh = target.height();
    var _dt = Number(target.css("top").replace("px", ""));
    var _dl = Number(target.css("left").replace("px", ""));

    target
      .stop()
      .queue([])
      .css({
        top: _dt + "px",
        left: _dl + "px",
        visibility: "visible",
        opacity: 1,
      })
      .delay(delay)
      .animate(
        {
          top: _dt + _dh / 2 + "px",
          left: _dl + _dw / 2 + "px",
          opacity: 0,
        },
        duration,
        easing,
        function () {
          $(this).css({
            top: _dt + "px",
            left: _dl + "px",
          });
          if (func && typeof func == "function") {
            func();
          }
        }
      );

    target
      .find("img")
      .stop()
      .queue([])
      .css({
        height: _dh + "px",
        width: _dw + "px",
      })
      .delay(delay)
      .animate(
        {
          height: 0,
          width: 0,
        },
        duration,
        easing,
        function () {
          $(this).css({
            height: options && options.img_h ? options.img_h : _dh + "px",
            width: options && options.img_w ? options.img_w : _dw + "px",
          });
          if (func && typeof func == "function") {
            func();
          }
        }
      );
  };

  window.Anime = Cls;
})(window, $brand);

function log() {
  if (typeof console == "undefined") return;

  var args = jQuery.makeArray(arguments);
}
